module.exports = __webpack_public_path__ + "img/Icon-transmission.f0bd9e62.png";